export class Interlocuteur {
    static jsonMap = {
        id: 'id',
        nom: { key: 'nom', optional: true, default: '' },
        prenom: { key: 'prenom', optional: true, default: '' }
    };

    id: number;
    nom: string;
    prenom: string;
    nomComplet: string;
}
